import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { AccountsVService, BillingAccountDetails, FindExistingBillingAccountQuery } from '../../services/V2/gozer';
import { getOperatorId, handleError } from '../Shared/Functions';
import { FindExistingAccount } from '../Shared/FindExistingAccount';

export function AddAccountModal({ hide, show, reload, fail, success }) {
    const [step, setStep] = useState<number>(0);
    const [operatorId, setOperatorId] = useState<string>("");
    const [user, setUser] = useState<BillingAccountDetails>();
    const [ready, setReady] = useState<boolean>(true);
    const [loading, setLoading] = useState<boolean>(false);
    const [findUser, setFindUser] = useState<FindExistingBillingAccountQuery>({
        accountNumber: "",
        fullName: "",
        districtId: "",
        hasUser: false,
        operatorId: operatorId
    });

    useEffect(() =>{
        if(step === 0) {
            setLoading(true);
            getOperatorId()
                .then((x:any) => {
                    setOperatorId(x ?? "")
                    setLoading(false);
                })
        } else if(step === 1 && findUser) {
            AccountsVService.accountsVFindExistingBillingAccount({
                    ...findUser,
                    operatorId: operatorId,
                    hasUser: false
                })
                .then(x => {
                    if(x === null) {
                        fail("No active billing account matched your search.")
                        setStep(0);
                        setReady(true)
                        return;
                    }
                    setUser(x)
                    setReady(true)
                })
                .catch(err => {
                    err.message !=="Not Found" && fail(handleError(err))
                    setReady(true)
                })
        }
        if(step === 2) {
            setLoading(true)
            AccountsVService.accountsVAddAccount(user?.id ?? "", findUser.accountNumber)
                    .then(x => {
                        reload()
                        success("Account Added")
                        hide()
                        setLoading(false)
                    })
                    .catch(err => {
                        err.message !=="Not Found" && fail(handleError(err))
                        setLoading(false)
                    })
        }
    }, [step])// eslint-disable-line react-hooks/exhaustive-deps

    return <>
        <Dialog onClose={hide} open={show} fullWidth={true} maxWidth={"xs"}>
            <DialogTitle>Add Account</DialogTitle>
            <DialogContent>
                <form>
                    {step === 0 &&
                        <FindExistingAccount
                            findUser={findUser}
                            setFindUser={setFindUser}
                            operatorId={operatorId}
                        />
                    }
                    {step === 1 ? (ready ?
                        <div className='text-center'>
                            <p className="text-muted"><b>Confirm your account.</b></p>
                            <br />
                            <div><b>Account Number</b></div>
                            <div>{user?.accountNumber}</div>
                            <br />
                            <div><b>Name</b></div>
                            <div>{user?.customer?.fullName}</div>
                            <br />
                            <div><b>Address</b></div>
                            <div>{user?.customer?.street}</div>
                            <div>{user?.customer?.city}, {user?.customer?.state} {user?.customer?.zip}</div>
                        </div>
                        :
                        <>
                            <div className='loading-container'><CircularProgress className='center-spinner' color="primary" aria-label="Loading" /></div>
                            <div className='text-center'>Searching for account...</div>
                        </>) : null
                    }
                </form>
            </DialogContent>
            <DialogActions className='add-account-buttons-group'>
                <Button variant="outlined" onClick={hide} style={{marginRight:"10px"}}>
                    Cancel
                </Button>
                <Button variant="contained" 
                    onClick={() => {
                        setReady(false);
                        setStep(step+1);
                    }}>
                    {step === 0 ? "Continue" : "Save"}
                </Button>
            </DialogActions>
            {loading && <div className='loading-container'><CircularProgress className='center-spinner' color="primary" aria-label="Loading" /></div>}
        </Dialog>
    </>
}
